const defaultState = {};

const mutations = {
    // Client in the URL
    setContactState(state, contact) {
        Object.assign(state, contact);
    },
    resetContactState(state) {
        Object.keys(state).forEach(key => {
            delete state[key];
        });
    },
};

const actions = {
    async getContactInfo({ commit, dispatch }, contactId) {
        try {
            const { data } = await this.$rq.getContact(contactId);
            commit('setContactState', data);
        } catch (err) {
            dispatch('resetContactInfo');
        }
    },
    resetContactInfo({ commit }) {
        commit('resetContactState');
    },
};

const getters = {
    contact: state => state,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
